import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { SyncDashboardData } from '@/types/accounting-sync';

export function useAccountingSyncDashboard() {
  return useApiQuery<SyncDashboardData>({
    queryKey: settingsKeys.accountingDashboard(),
    queryFn: () =>
      apiGet<SyncDashboardData>(operationsClient, settingsEndpoints.accountingSyncDashboard()),
    refetchInterval: 30_000,
    staleTime: 10_000,
    showErrorToast: false,
  });
}
